module.exports = __webpack_public_path__ + "img/8.91b9db3.webp";